<template>
  <div>
    <div class="mode-switch offer-wizard-steps" style="margin-bottom: 14px">
      <button type="button" class="mode-btn" :class="{ active: po.offerWizardStep === 1 }" @click="po.offerWizardStep = 1">1. Orari</button>
      <button type="button" class="mode-btn" :class="{ active: po.offerWizardStep === 2 }" :disabled="!po.offerWizardCanContinueStep1()">2. Rregulla</button>
      <button type="button" class="mode-btn" :class="{ active: po.offerWizardStep === 3 }" :disabled="!po.offerWizardCanContinueStep2()">3. Parashiko</button>
      <button type="button" class="mode-btn" :class="{ active: po.offerWizardStep === 4 }" :disabled="!po.offerWizardCanContinueStep3()">4. Publiko</button>
    </div>

    <div v-show="po.offerWizardStep === 1" class="panel-card">
      <div class="section-title">Hapi 1: Orari i ofertës</div>
      <fieldset class="offer-fieldset">
        <div class="field-grid">
          <label>Etiketa e ofertës (opsionale)</label>
          <input v-model="po.offerForm.label" class="input-clean" type="text" placeholder="P.sh. Periudha 1–15" />
          <label class="inline-check">
            <input type="checkbox" v-model="po.offerForm.is_price_locked" />
            Blloko cmimin e kësaj oferte
          </label>
          <p class="empty-note" style="margin: 0">
            Në overlap: oferta e bllokuar fiton mbi të pablokuara; pastaj fiton çmimi më i ulët.
          </p>
          <div class="field-grid two-col">
            <div>
              <label>Fillon me *</label>
              <Datepicker
                :model-value="po.offerForm.start_at"
                :start-time="{ hours: 0, minutes: 0, seconds: 0 }"
                :enable-time-picker="true"
                :is-24="true"
                :minutes-increment="1"
                :clearable="true"
                auto-apply
                model-type="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                @update:model-value="po.onOfferScheduleStartUpdate"
              />
            </div>
            <div>
              <label>Mbaron me *</label>
              <Datepicker
                :model-value="po.offerForm.end_at"
                :start-time="{ hours: 0, minutes: 0, seconds: 0 }"
                :enable-time-picker="true"
                :is-24="true"
                :minutes-increment="1"
                :clearable="true"
                auto-apply
                model-type="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                @update:model-value="po.onOfferScheduleEndUpdate"
              />
            </div>
          </div>
        </div>
      </fieldset>
    </div>

    <div v-show="po.offerWizardStep === 2">
      <div class="panel-card import-panel">
        <div class="section-title">Importo nga Excel / CSV</div>
        <p class="empty-note" style="margin-bottom: 8px">
          Si te Çmimet: shkarko shabllonin, plotëso kodet + çmimin e ofertes, ngarko .xlsx / .csv, pastaj shto si rregulla.
          Çmimi shkruhet te kolona <strong>price</strong> (nga bazë → cmim shitjeje).
        </p>
        <div class="quick-actions">
          <button type="button" class="button is-small" @click="po.downloadOfferImportTemplate">Shkarko shabllonin</button>
          <input class="input-clean" type="file" accept=".csv,.xlsx,.xls" @click="$event.target.value = null" @change="po.onOfferImportFilePicked" />
          <button type="button" class="button is-small is-info" :disabled="!po.offerImportValidRows.length || po.offerImportLoading" @click="po.applyOfferImportAsRules">
            Shto si rregulla ({{ po.offerImportValidRows.length }})
          </button>
          <button
            v-if="po.offerImportErrorDownloadAvailable"
            type="button"
            class="button is-small is-light is-danger"
            :disabled="po.offerImportLoading"
            @click="po.downloadOfferImportErrorsJson"
          >
            Shkarko gabimet (JSON)
          </button>
        </div>
      </div>

      <div class="panel-card">
        <div class="section-title">Rregullat e ofertes</div>
        <fieldset class="offer-fieldset">
          <div class="compact-toolbar">
            <select v-model="po.offerRuleDraft.related_entity" class="input-clean">
              <option value="products">Produkte</option>
              <option value="accessories">Aksesore</option>
            </select>
            <select v-model="po.offerRuleDraft.scope" class="input-clean">
              <option value="all">Te gjitha</option>
              <option value="tree">Nga pema</option>
              <option value="selected">Produkte te zgjedhura</option>
            </select>
            <span class="empty-note" style="align-self: center; white-space: nowrap" title="Zbritja llogaritet nga cmimi bazë dhe aplikohet te cmimi">
              Nga bazë → cmim
            </span>
            <select v-model="po.offerRuleDraft.discount_type" class="input-clean">
              <option value="percentage">Perqindje (%)</option>
              <option value="flat">Fikse (lek)</option>
              <option value="fixed_price">Cmimi i ri (lek)</option>
            </select>
            <input v-model.number="po.offerRuleDraft.amount" class="input-clean" type="number" min="0" step="0.01" placeholder="Vlera" />
            <button type="button" class="button is-small" @click="po.addOfferRule">+ Shto rregull</button>
          </div>

          <div class="quick-actions">
            <input v-model="po.offerProductSearch" class="input-clean" type="text" placeholder="Kerko produkt..." />
            <button type="button" class="button is-small" @click="po.clearOfferRuleFilters">Pastro filtrat</button>
            <span class="counter">Rregulla: {{ po.offerRules.length }}</span>
          </div>

          <div v-if="po.offerRuleDraft.scope === 'tree'" class="compact-tree-filter">
            <div class="quick-actions">
              <input v-model="po.offerTreeSearch" class="input-clean" type="text" placeholder="Kerko kategori..." />
              <button type="button" class="button is-small" @click="po.clearOfferTreeFilter">Pastro pemen</button>
            </div>
            <div class="tree-wrap compact-tree">
              <div
                v-for="node in po.offerVisibleTreeNodes"
                :key="`offer-${node.guid}`"
                class="tree-row"
                :class="{ selected: po.offerRuleDraft.leaf_guid === node.guid }"
                :style="{ paddingLeft: `${8 + node.depth * 16}px` }"
                @click="po.selectOfferTreeNode(node)"
              >
                <button type="button" class="icon-btn" v-if="node.hasChildren" @click.stop="po.toggleOfferNode(node.guid)">
                  <i class="fa" :class="po.isOfferCollapsed(node.guid) ? 'fa-plus-square' : 'fa-minus-square'"></i>
                </button>
                <span v-else class="dot">•</span>
                <span class="tree-label">{{ node.name }}</span>
              </div>
            </div>
          </div>

          <div class="manual-table-wrap" v-if="po.offerRuleDraft.scope === 'selected'">
            <table class="table is-fullwidth is-narrow">
              <thead>
                <tr>
                  <th style="width: 32px"></th>
                  <th>Kodi</th>
                  <th>Emri</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in po.offerFilteredProducts" :key="`offer-p-${p.id}`">
                  <td><input type="checkbox" :checked="po.offerRuleDraft.product_ids.includes(String(p.id))" @change="po.toggleOfferProductSelection(p.id)" /></td>
                  <td>{{ p.code }}</td>
                  <td>{{ p.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="manual-table-wrap" v-if="po.offerRules.length">
            <table class="table is-fullwidth is-narrow">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Entity</th>
                  <th>Scope</th>
                  <th>Aplikim</th>
                  <th>Vlera</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rule, idx) in po.offerRules" :key="`rule-${idx}`">
                  <td>{{ idx + 1 }}</td>
                  <td>{{ po.offerEntityLabel(rule.related_entity) }}</td>
                  <td>{{ po.offerScopeLabel(rule.scope) }}</td>
                  <td>{{ po.offerTargetLabel(rule.target_field) }}</td>
                  <td>{{ po.money(rule.amount) }}</td>
                  <td><button type="button" class="icon-btn" @click="po.removeOfferRule(idx)"><i class="fa fa-times"></i></button></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="empty-note">Shto të paktën një rregull.</div>
        </fieldset>
      </div>
    </div>

    <div v-show="po.offerWizardStep === 3" class="panel-card">
      <div class="section-title">Hapi 3: Parashiko ndikimin</div>
      <div class="quick-actions">
        <button type="button" class="button is-primary" @click="po.simulateOfferDraft({ announce: true })" :disabled="po.offerSimulationLoading">
          {{ po.offerSimulationLoading ? "Duke simuluar..." : "Ekzekuto parashikimin" }}
        </button>
      </div>
      <OfferSimulationPreview v-if="po.offerSimulationRan" />
      <p v-else class="empty-note">Duhet të ekzekutosh parashikimin para hapës së publikimit.</p>
    </div>

    <div v-show="po.offerWizardStep === 4" class="panel-card">
      <div class="section-title">Hapi 4: Publiko ofertën</div>
      <div class="result-card">
        <div class="result-item"><strong>Etiketa:</strong> {{ po.offerForm.label || "—" }}</div>
        <div class="result-item"><strong>Orari:</strong> {{ po.formatTimelinePeriod(po.offerForm.start_at, po.offerForm.end_at) }}</div>
        <div class="result-item"><strong>Rregulla:</strong> {{ po.offerRules.length }}</div>
        <div class="result-item"><strong>Produkte të prekura (simulim):</strong> {{ po.offerSimulationAffected }}</div>
      </div>
      <div class="quick-actions" style="margin-top: 12px">
        <button type="button" class="button is-success" :disabled="po.offerPublishLoading || !po.offerCanPublish || !po.offerSimulationRan" @click="po.requestPublishOfferDraft">
          {{ po.offerPublishLoading ? "Duke publikuar..." : "Publiko ofertën" }}
        </button>
      </div>
    </div>

    <div class="wizard-nav sticky-actions">
      <button v-if="po.offerWizardStep > 1" type="button" class="button is-light" @click="po.offerWizardBack">Mbrapa</button>
      <span class="offer-campaign-modal-foot-spacer"></span>
      <button v-if="po.offerWizardStep < 4" type="button" class="button is-primary" @click="po.offerWizardContinue">Vazhdo</button>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import OfferSimulationPreview from "./OfferSimulationPreview.vue";

export default {
  name: "OfertaWizard",
  components: { Datepicker, OfferSimulationPreview },
  inject: ["po"],
};
</script>

<style scoped>
.wizard-nav {
  margin-top: 14px;
}
</style>
